import { tran } from '../../../translations/schema/TranslationSchema';

export const OptionsTranslationSchema = tran.array(
  tran.object({
    label: tran.rte(),
  }),
);
